/**
 * @author Vibhor Sharma <vibhor.sharma@314ecorp.com>
 * @description ShowCodeAttributeDetails component
 */
import { Modal, Typography } from 'antd';
import { useState } from 'react';

import EventTracker from 'utils/eventTracker';
import { EVENTS } from 'app-constants/events';

const ShowCodeAttributeDetails: React.FC<{ code: string; htmlString: string }> = ({ code, htmlString }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Typography.Link
				data-testid='ce-attr-details-link'
				onClick={() => {
					setIsOpen(true);
					EventTracker.trackEvent(EVENTS.codeExplorer.codeAttributeSeeMoreClicked(code));
				}}
			>
				{code}
			</Typography.Link>
			<Modal
				data-testid='ce-attr-details-modal'
				open={isOpen}
				onCancel={() => setIsOpen(false)}
				footer={null}
				centered
				width={'80%'}
				classNames={{ body: 'rounded-lg max-h-[600px] py-4 px-6 overflow-auto flex flex-col' }}
				destroyOnHidden
			>
				<div dangerouslySetInnerHTML={{ __html: htmlString }} />
			</Modal>
		</>
	);
};

export default ShowCodeAttributeDetails;
